import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateRegEdSubmissions } from './useRegEdSubmissionsQuery';

/**
 * Renders the compliance PDF for the campaign's open round. `ComplianceProviderGate` files nothing
 * without one, so a revision that skips this is never actually submitted — and says so to nobody.
 */
export const useRegEdEmailRegenerateCompliancePdfMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			campaignId,
			impersonationContext,
		}: {
			campaignId: string;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			userSession.webServiceHelper.callAsync<void>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `email/${encodeURIComponent(campaignId)}/regenerateCompliancePDF`,
				}),
				'POST'
			),
		onError,
		onSuccess: (_, { campaignId }) => {
			invalidateRegEdSubmissions(campaignId);
			onSuccess?.();
		},
	});
};
